import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';


const propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object,
    ]),
};

const { Text, Paragraph } = Typography;

const BookingTableRowItemValue = ({ label, value = '' }) => {
    return (
        <Paragraph>
            <Text strong>{ label }: </Text> { value }
        </Paragraph>
    );
};

BookingTableRowItemValue.propTypes = propTypes;

export default BookingTableRowItemValue;
